
    // @ts-ignore
    module.exports = __webpack_public_path__ + "recording-processor.worklet.js";
    